import { render, staticRenderFns } from "./BtnAtualizarSubItemContrato.vue?vue&type=template&id=d661f61e"
import script from "./BtnAtualizarSubItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarSubItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports